import { lazy, Suspense } from "react";
import {
  MarketingHeader,
  HeroSection,
  MarketingFooter,
} from "@/components/marketing";

// Lazy load below-the-fold sections to reduce initial JS execution
const ProductShowcaseSection = lazy(() => 
  import("@/components/marketing/ProductShowcaseSection").then(m => ({ default: m.ProductShowcaseSection }))
);
const TestimonialsSection = lazy(() => 
  import("@/components/marketing/TestimonialsSection").then(m => ({ default: m.TestimonialsSection }))
);
const FounderNoteSection = lazy(() => 
  import("@/components/marketing/FounderNoteSection").then(m => ({ default: m.FounderNoteSection }))
);
const FAQSection = lazy(() => 
  import("@/components/marketing/FAQSection").then(m => ({ default: m.FAQSection }))
);
const PricingSection = lazy(() => 
  import("@/components/marketing/PricingSection").then(m => ({ default: m.PricingSection }))
);
const FinalCTASection = lazy(() => 
  import("@/components/marketing/FinalCTASection").then(m => ({ default: m.FinalCTASection }))
);

// Minimal loading placeholder for lazy sections
function SectionSkeleton() {
  return <div className="py-16 md:py-24" aria-hidden="true" />;
}

export default function MarketingHome() {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <MarketingHeader />
      <main>
        {/* Hero loads immediately - above the fold */}
        <HeroSection />
        
        {/* Below-the-fold sections are lazy loaded */}
        <Suspense fallback={<SectionSkeleton />}>
          <ProductShowcaseSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <TestimonialsSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <FounderNoteSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <PricingSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <FinalCTASection />
        </Suspense>
      </main>
      <MarketingFooter />
    </div>
  );
}
